import FormFieldsCard from "components/lib/Global/FormFieldsCard";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import _get from "lodash/get";
import { Constants } from "config/constants";
import { addComment, editComment } from "state/slices/comment";
import CommentsList from "components/lib/Global/CommentsList";
import { format } from "date-fns";
import { Field, Formik } from "formik";
import FileUploadForm from "components/PLCTABS/CompanyOfficialsTab/FileUploadForm";

const CompanySummary = ({ isViewMode = false }) => {
  const { company } = useSelector((state) => state.companySlice);
  const { comments } = useSelector((state) => state.commentsSlice);
  const { resolvedFields } = company || [];
  const dispatch = useDispatch();

  const companySummaryComments = comments.filter(
    (comment) => comment.formName === "companySummary"
  );
  const fileUploadComments = comments.filter(
    (comment) => comment.formName === "uploadDocuments"
  );

  const registrationDate = company?.registrationDate
    ? format(new Date(_get(company, "registrationDate")), "yyyy-MM-dd")
    : "";
  const annualReturnDate = company?.annualReturnDate
    ? format(new Date(_get(company, "annualReturnDate")), "yyyy-MM-dd")
    : "";

  const documentData = [
    { label: "KRA Pin", name: "kraPin" },
    { label: "NSSF No", name: "NSSFNo" },
    { label: "NHIF No", name: "NHIFNo" },
  ];

  const handleSaveComment = async (data) => {
    if (data?.commentId) {
      await dispatch(editComment({ commentId: data.commentId, data }));
    } else {
      await dispatch(
        addComment({
          data: {
            ...data,
            company: company._id,
          },
        })
      );
    }
  };

  return (
    <div>
      {companySummaryComments.length > 0 && (
        <div className="px-8 pt-5 pb-6 bg-white mb-6">
          <CommentsList
            comments={companySummaryComments}
            toggleCommentStatus={!isViewMode}
          />
        </div>
      )}
      {fileUploadComments.length > 0 && (
        <div className="px-8 pt-5 pb-6 bg-white mb-6">
          <CommentsList
            comments={fileUploadComments}
            toggleCommentStatus={!isViewMode}
          />
        </div>
      )}
      <div className="bg-white rounded-md">
        <FormFieldsCard
          fields={[
            {
              key: "Registration Name",
              name: "registrationName",
              value: _get(company, "registrationName", "N/A"),
            },
            {
              key: "Registration Number",
              name: "registrationNumber",
              value: _get(company, "registrationNumber", "N/A"),
            },
            {
              key: "Entity Type",
              name: "type",
              value:
                Constants.ENTITY_TYPE_AGAINST_TYPE[
                  _get(company, "type", "N/A")
                ],
            },
            {
              key: "Entity Status",
              name: "entityStatus",
              value: _get(company, "status", "N/A"),
            },
            {
              key: "Registration Date",
              name: "registrationDate",
              value: registrationDate || "N/A",
            },
            {
              key: "Annual Return Date",
              name: "annualReturnDate",
              value: annualReturnDate || "N/A",
            },
            {
              key: "kraPin",
              name: "kraPin",
              value: _get(company, "kraPin", "N/A"),
            },
            {
              key: "NSSFNo",
              name: "NSSF No",
              value: _get(company, "NSSFNo", "N/A"),
            },
            {
              key: "NHIFNo",
              name: "NHIF No",
              value: _get(company, "NHIFNo", "N/A"),
            },
          ]}
          addReviewComment={!isViewMode}
          resolvedFields={resolvedFields}
          formName="companySummary"
          formHelperKey="company"
          updateEffectKey="updateCompanyFormationState"
          formId={_get(company, "_id")}
          handleSaveComment={handleSaveComment}
          comments={comments}
          hideResolveAllCheckbox={isViewMode}
          isViewMode={isViewMode}
        />

        <div className="mt-2">
          <Formik
            enableReinitialize
            initialValues={{
              fileUploads: company.fileUploads,
            }}
            onSubmit={() => null}
          >
            {() => {
              return (
                <div className="pl-4">
                  <Field
                    name="fileUploads"
                    component={FileUploadForm}
                    documentData={documentData}
                    resolvedFields={resolvedFields}
                    onlyPreview
                    showDocumentLabel
                    addReviewComment={!isViewMode}
                    hideResolveAllCheckbox={isViewMode}
                    handleSaveComment={handleSaveComment}
                    formName="uploadDocuments"
                    formHelperKey="company"
                    updateEffectKey="updateCompanyFormationState"
                    formId={_get(company, "_id")}
                    resolveAllFieldsCheckbox
                    fileUploadComments={fileUploadComments}
                  />
                </div>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default CompanySummary;
